import React, { useEffect, useState } from "react";
import { useAuth, isStudent } from "../../contexts/AuthContext";
import { Alert, Box, Button, Link, Snackbar, Typography, useTheme } from "@mui/material";
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";
import { useNavigate } from "react-router-dom";
import AsyncButton from "../common/AsyncButton";

function Tncbanner() {
    const { user, logout } = useAuth();
    const theme = useTheme();
    const [tnc, setTnc] = useState({ "ID": 0 })
    const navigate = useNavigate();
    const [state, setState] = useState({ open: false, message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const getTnCStats = async () => {
        const response = await InvokeAPI(`${getUserMgmtBase()}/v1/user/tnc/accept/status`,
            {},
            'POST',
            { "authorization": user["token"] },
            false)
        if (response.unauthenticated == true) {
            logout(user);
        }
        return response.response
    }
    useEffect(() => {

        getTnCStats().then(data => setTnc({"ID":parseInt(data["ID"], 10),"Content": data["Content"] }))
    }, [])

    const acceptTnc = async () => {
        const response = await InvokeAPI(`${getUserMgmtBase()}/v1/user/tnc/accept`,
            { "TermsId": tnc["ID"] },
            'POST',
            { "authorization": user["token"] },
            false)
        if (response.unauthenticated == true) {
            logout(user);
        } else if (response.internal == true) {
            setState({ open: true, severity: "error", message: "Internal error while trying to accept TnC. Please try later." });
        } else {
            setState({ open: true, severity: "success", message: "Latest Terms and Conditions accepted." });
            getTnCStats().then(data => setTnc({"ID":parseInt(data["ID"], 10),"Content": data["Content"] }))
        }
    }

    return (
        <>
            {isStudent() ?
                <></> :
                <>
                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        open={state.open}
                        onClose={handleClose}
                        key={state.message}
                        autoHideDuration={3000}
                        TransitionProps={{ timeout: 300 }}
                    >
                        <Alert 
                            variant="filled" 
                            severity={state.severity}
                            sx={{
                                animation: 'slideUp 0.3s ease-out',
                                '@keyframes slideUp': {
                                    from: {
                                        opacity: 0,
                                        transform: 'translateY(-20px)',
                                    },
                                    to: {
                                        opacity: 1,
                                        transform: 'translateY(0)',
                                    },
                                },
                            }}
                        >
                            {state.message}
                        </Alert>
                    </Snackbar>
                    {tnc["ID"] != 0 ?
                        <Box 
                            display="flex" 
                            justifyContent="left" 
                            alignItems="center" 
                            textAlign="left" 
                            sx={{ 
                                padding: '12px 16px', 
                                width: '100%', 
                                zIndex: 1000, 
                                position: 'fixed', 
                                bottom: '0', 
                                background: theme.palette.mode === 'dark' 
                                    ? 'linear-gradient(135deg, #f57c00 0%, #e65100 100%)'
                                    : 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                                color: theme.palette.mode === 'dark' ? '#ffffff' : '#1a1a1a',
                                boxShadow: theme.palette.mode === 'dark' 
                                    ? '0 -4px 20px rgba(0,0,0,0.5)'
                                    : '0 -4px 20px rgba(0,0,0,0.2)',
                                animation: 'slideUp 0.4s ease-out',
                                '@keyframes slideUp': {
                                    from: {
                                        opacity: 0,
                                        transform: 'translateY(100%)',
                                    },
                                    to: {
                                        opacity: 1,
                                        transform: 'translateY(0)',
                                    },
                                },
                            }}
                        >
                            <Typography sx={{ flexGrow: 1, mr: 2 }}>
                                Our Terms of Use have changed, please review <Link 
                                    sx={{ 
                                        color: theme.palette.mode === 'dark' ? '#fff9c4' : '#1a237e',
                                        textDecoration: 'none',
                                        fontWeight: 600,
                                        '&:hover': {
                                            textDecoration: 'underline',
                                            opacity: 0.8,
                                        },
                                    }} 
                                    href="/tnc" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    here
                                </Link>. &nbsp;
                            
                            <AsyncButton 
                                onClick={acceptTnc} 
                                type="submit" 
                                variant="contained" 
                                sx={{ 
                                    minWidth: '140px',
                                    backgroundColor: theme.palette.mode === 'dark' ? '#fff9c4' : '#1a237e',
                                    color: theme.palette.mode === 'dark' ? '#e65100' : '#ffffff',
                                    fontWeight: 600,
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        backgroundColor: theme.palette.mode === 'dark' ? '#fff59d' : '#283593',
                                        transform: 'translateY(-2px)',
                                        boxShadow: (theme) => theme.shadows[8],
                                    },
                                }}
                            >
                                Click To Accept
                            </AsyncButton>
                            </Typography>
                        </Box>
                        : <></>}
                </>
            }
        </>
    );
}

export default Tncbanner;